import React from 'react';
import { MessageCircle } from 'lucide-react';

export const LandingCta = ({ navigate, setShowInquiryForm, t }) => (
      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-r from-orange-600 via-red-600 to-orange-600 relative overflow-hidden">
        {/* Decorative Pattern */}
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 left-0 w-96 h-96 border-4 border-white rounded-full"></div>
          <div className="absolute bottom-0 right-0 w-96 h-96 border-4 border-white rounded-full"></div>
        </div>

        <div className="mx-auto max-w-4xl text-center relative z-10">
          <h2 className="font-heading text-4xl lg:text-5xl font-bold text-white mb-6">
            {t('landing.ctaTitle')}
          </h2>
          <p className="text-xl text-orange-100 mb-10">
            {t('landing.ctaSubtitle')}
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={() => setShowInquiryForm(true)}
              className="px-10 py-4 bg-white text-orange-600 rounded-xl font-bold text-lg hover:shadow-2xl transition-all transform hover:scale-105 flex items-center justify-center gap-2"
              data-testid="cta-register-button"
            >
              <MessageCircle className="w-5 h-5" />
              Get Free Consultation
            </button>
            <button
              onClick={() => navigate('/treatments')}
              className="px-10 py-4 bg-transparent border-2 border-white text-white rounded-xl font-bold text-lg hover:bg-white hover:text-orange-600 transition-all"
            >
              Explore Treatments
            </button>
          </div>
        </div>
      </section>
);
